import { render, staticRenderFns } from "./Asistencia.vue?vue&type=template&id=031e3043"
import script from "./Asistencia.vue?vue&type=script&lang=js"
export * from "./Asistencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports